import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  props: {
    audiSettingInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      checkedAec: '',
      checkedAns: '',
      checkedAgc: '',
      audioMode: 'mono',
      audioProfile: 'music_standard',
      audioSettingList: [{
        type: 'AEC',
        checked: false,
        i18n: 'common.aecTips',
        localKey: 'checkedAec'
      }, {
        type: 'ANS',
        checked: false,
        i18n: 'common.ansTips',
        localKey: 'checkedAns'
      }, {
        type: 'AGC',
        checked: false,
        i18n: 'common.agcTips',
        localKey: 'checkedAgc'
      }]
    };
  },
  computed: {
    profiles() {
      if (this.audioMode === 'mono') {
        return [{
          text: 'Speech Low Quality (Rate 16Khz,Bitrate 24Kbps)',
          value: 'speech_low_quality'
        }, {
          text: 'Speech Standard (Rate 32Khz,Bitrate 24Kbps)',
          value: 'speech_standard'
        }, {
          text: 'Music Standard (Rate 48Khz,Bitrate 32Kbps)',
          value: 'music_standard'
        }, {
          text: 'High Quality (Rate 48Khz,Bitrate 128Kbps)',
          value: 'high_quality'
        }];
      } else {
        return [{
          text: 'Standard Stereo (Rate 48Khz,Bitrate 64Kbps)',
          value: 'standard_stereo'
        }, {
          text: 'High Quality Stereo (Rate 48Khz,Bitrate 192Kbps)',
          value: 'high_quality_stereo'
        }];
      }
    }
  },
  created() {
    this.checkedAec = handleLocalStorage('get', 'checkedAec') ? JSON.parse(handleLocalStorage('get', 'checkedAec')) : true;
    this.checkedAns = handleLocalStorage('get', 'checkedAns') ? JSON.parse(handleLocalStorage('get', 'checkedAns')) : true;
    this.checkedAgc = handleLocalStorage('get', 'checkedAgc') ? JSON.parse(handleLocalStorage('get', 'checkedAgc')) : true;
    this.audioProfile = handleLocalStorage('get', 'audioProfile') || 'music_standard';
    if (!this.checkedAec && !this.checkedAns && !this.checkedAgc && (this.audioProfile == 'standard_stereo' || this.audioProfile == 'high_quality_stereo')) {
      this.audioMode = 'stereo';
    } else {
      this.audioMode = 'mono';
    }
    this.setAduioNoisySetting();
  },
  methods: {
    setAduioNoisySetting() {
      this.audioSettingList.forEach(item => {
        switch (item.type) {
          case 'AEC':
            item.checked = this.checkedAec;
            break;
          case 'ANS':
            item.checked = this.checkedAns;
            break;
          case 'AGC':
            item.checked = this.checkedAgc;
            break;
        }
      });
    },
    setAduioSetting() {
      handleLocalStorage('set', 'checkedAec', this.checkedAec);
      handleLocalStorage('set', 'checkedAns', this.checkedAns);
      handleLocalStorage('set', 'checkedAgc', this.checkedAgc);
      handleLocalStorage('set', 'audioProfile', this.audioProfile);
      this.audiSettingInfo.show = false;
      if (this.$route.name != 'preview') {
        window.location.reload();
      }
    },
    cancelAudioSetting() {
      this.audiSettingInfo.show = false;
    },
    saveOperation(key, val) {
      this[key] = val;
    },
    // 切换音频模式
    onAudioModeChange(newMode) {
      // 切换音频模式时，重置aec、agc、ans
      // 单声道的音频质量，默认为 music_standard
      // 立体声的音频质量，默认为 standard_stereo
      this.audioProfile = newMode === 'mono' ? 'music_standard' : 'standard_stereo';
      this.checkedAec = false;
      this.checkedAgc = false;
      this.checkedAns = false;
      this.setAduioNoisySetting();
    },
    cancelAdvanced() {
      this.audiSettingInfo.show = false;
    },
    // 保存关闭
    closeAdvanced() {
      localStorage.setItem('checkedAec', this.checkedAec);
      localStorage.setItem('checkedAns', this.checkedAns);
      localStorage.setItem('checkedAgc', this.checkedAgc);
      localStorage.setItem('audioProfile', this.audioProfile);
      this.audiSettingInfo.show = false;
      if (this.$route.name == 'coordinationParticipate') {
        window.location.reload();
      }
    }
  }
};